export const GET_ALBUMS_URL = '/albums';
export const SEARCH_ALBUMS_URL = '/albums/search';
export const EXPORT_ALBUMS_URL = '/albums/export';
export const GET_ALBUM_DETAILS_URL = (id) => `/albums/${id}`;
export const GET_ALBUM_SONGS_URL = (id) => `/albums/${id}/songs`;
export const GET_ALBUM_ARTISTS_URL = (id) => `/albums/${id}/artists`;
export const CREATE_ALBUM_URL = '/albums';
export const UPDATE_ALBUM_URL = (id) => `/albums/${id}`;
export const DELETE_ALBUM_URL = (id) => `/albums/${id}`;
export const GET_RECORD_LABEL_DROPDOWN_URL = '/albums/record-labels/dropdown';
export const GET_SONG_DROPDOWN_URL = '/albums/songs/dropdown';
